import React from 'react'
import {
    VerticalTimeline,
    VerticalTimelineElement,
} from 'react-vertical-timeline-component'
import { getOrderEvents } from '../../../helpers/restHelpers'
import Loader from '../../loaders'
import '../../../assets/css/vertical-timeline.css'
import { getEventInfo } from '../../../utils/tracking'
import { formatDate } from '../../../utils/dateUtils'
import { strings } from '../../../localization/strings'
import routes from '../../router/routes'
import Signature from '../trackingForm/signature'
import TrackingShare from '../trackingForm/trackingShare'

class TrackingContent extends React.Component {
    state = {
        loading: false,
        tracking: null,
    }

    componentDidMount() {
        this.setState({ loading: true })
        getOrderEvents(this.props.orderId)
            .then((tracking) => this.setState({ tracking: tracking }))
            .catch((error) => {
                this.setState({ tracking: null })
                window.showDialog(error, () => {
                    this.props.history.push(routes.orders.path)
                })
            })
            .finally(() => this.setState({ loading: false }))
    }

    render() {
        if (this.state.loading) return <Loader />

        const { tracking } = this.state
        const { events } = tracking || {}

        return (
            <div
                style={{
                    maxWidth: '100%',
                    flexGrow: 1,
                    height: '100%',
                    overflowY: 'auto',
                }}
            >
                <div>
                    {!tracking ? null : <Signature tracking={tracking} />}
                    {!tracking ? null : (
                        <TrackingShare
                            url={tracking.trackingUrl}
                            trackingNumber={tracking.trackingNumber}
                            mail={tracking.mail}
                            mobilePhoneNumber={tracking.mobilePhoneNumber}
                            canSendSms={tracking.canSendSms}
                            orderId={tracking.orderId}
                        />
                    )}

                    {!events ? null : !events.length ? (
                        <div className={'centered-element-container'}>
                            <h2>{strings.trackingFormResponseEmpty}</h2>
                        </div>
                    ) : (
                        <VerticalTimeline layout={'1-column'}>
                            {events.map((event, index) => {
                                const [style, title, message, date] =
                                    getEventInfo(event)
                                const warehouse = event.warehouse
                                return (
                                    <VerticalTimelineElement
                                        key={index}
                                        className="vertical-timeline-element--work"
                                        date={formatDate(date)}
                                        iconStyle={{
                                            background: style.backgroundColor,
                                            color: '#fff',
                                        }}
                                        icon={style.icon}
                                    >
                                        <h3 className="vertical-timeline-element-title">
                                            {title}
                                        </h3>
                                        {warehouse && warehouse.city ? (
                                            <p
                                                style={{ margin: 0 }}
                                                className="vertical-timeline-element-subtitle"
                                            >
                                                {warehouse.city}
                                            </p>
                                        ) : null}
                                        {message ? (
                                            <h4 className="vertical-timeline-element-subtitle">
                                                {message}
                                            </h4>
                                        ) : null}
                                    </VerticalTimelineElement>
                                )
                            })}
                        </VerticalTimeline>
                    )}
                </div>
            </div>
        )
    }
}

export default TrackingContent
